import { useSelector } from 'react-redux';
import { getLoggedInUserSubscription, getUser } from '../../store/iam/selectors';
import { useFetchSubscriptionPlansQuery, useFetchSubscriptionQuery } from '../service';
import { useMemo } from 'react';
import { getPlanDetails } from '../utils';
import { Plan, Subscription, UserSubscription } from '../types';
import moment from 'moment';

/**
 * Adds the plan details for a subscription from the jwt token
 * @param planDetails
 * @param loggedInSubscription
 * @param subscription
 * @returns
 */
function patchSubscription(planDetails: Plan, loggedInSubscription: Record<string, any>, subscription: Subscription, user: any): UserSubscription {
    const patchedSubscription = { ...loggedInSubscription };

    patchedSubscription.plan_details = { ...planDetails };
    patchedSubscription.current_period_ends_at = subscription.current_period_ends_at;
    patchedSubscription.trial_ends_at = subscription.trial_ends_at;

    if (user && user.override_plan && user.override_plan.allow_white_label_reports) {
        patchedSubscription.plan_details.settings.allow_white_label_reports = user.override_plan.allow_white_label_reports;
    }

    return patchedSubscription as UserSubscription;
}

/**
 * Hook that returns the logged in user subscription using the plan code from the JWT Token and details from plans endpoint
 * @returns
 */
export default function useGetSubscription() {
    const { data: plans, isLoading: isLoadingPlans } = useFetchSubscriptionPlansQuery();
    const { data: subscription, isLoading: isLoadingSubscription } = useFetchSubscriptionQuery();

    // TODO Refactor this after IAM refactor
    const loggedInSubscription = useSelector((state) => getLoggedInUserSubscription(state));
    // TODO Refactor this after IAM Refactor
    const user = useSelector((state) => getUser(state));

    const loggedInUserPlanDetails =
        plans && loggedInSubscription && loggedInSubscription.plan_code ? getPlanDetails(plans, loggedInSubscription.plan_code) : undefined;

    const hasData = !!subscription && !!loggedInUserPlanDetails;

    // Combine plan details from jwt subscription with endpoint subscription
    const patchedSubscription = useMemo(
        () => (hasData ? patchSubscription(loggedInUserPlanDetails, loggedInSubscription, subscription, user) : undefined),
        [hasData, loggedInUserPlanDetails, loggedInSubscription, subscription, user]
    );

    const isLoading = isLoadingPlans || isLoadingSubscription;
    const isInFreeTrial = !!patchedSubscription && !!patchedSubscription.trial_ends_at && moment(patchedSubscription.trial_ends_at).isAfter(moment());

    return {
        userSubscription: patchedSubscription,
        isInFreeTrial,
        isLoading,
    };
}
